import { useAppDispatch } from "../../../../../redux/hooks";
import { fetchReprintDeliverySheet } from "../../../../../redux/api/expedition.api";
import { DeliverySheetsDataInterface } from "../../../../../redux/interfaces/expedition.interface";

import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";

function DeliverySheetActionButtons({
  itemId,
}: {
  itemId: string;
  crudData: DeliverySheetsDataInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();

  const fetchReprintSheetA4 = () => {
    if (itemId) {
      dispatch(
        fetchReprintDeliverySheet({
          idBorderou: itemId,
        }),
      );
    }
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Retiparire"
        withConfirmationModal={{
          modalTitle: "Retipareste borderou",
          modalSubtitle: "Esti sigur ca vrei sa retiparesti borderoul?",
          modalLeftButtonText: "Anuleaza",
          modalLeftButtonVariant: "outlined",
          modalRightButtonText: "Retipareste",
          modalRightButtonOnClick: fetchReprintSheetA4,
        }}>
        <SvgIcon type="PRINT_A4" fill="white" className="svg-icon-2" />
      </CustomButton>
    </div>
  );
}

export default DeliverySheetActionButtons;
